import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import _ from 'lodash';

const RenderWrapper = ({ children, withText, taskId, flyoutInformations, onTaskClick }) => {
  const className = 'brzw-calendar-single-task-wrapper';
  const isActiveTask = _.get(flyoutInformations, 'taskId') === taskId;

  return withText ? (
    <div
      className={classnames(className, {
        [`${className}--active`]: isActiveTask,
      })}
      onClick={onTaskClick}
      role="presentation"
    >
      {children}
    </div>
  ) : (
    children
  );
};

RenderWrapper.propTypes = {
  children: PropTypes.node,
  flyoutInformations: PropTypes.shape({}),
  onTaskClick: PropTypes.func,
  taskId: PropTypes.number,
  withText: PropTypes.bool,
};

export default RenderWrapper;
